import type { AllowedMimeType } from './viewerHtml';

const EXTENSION_TO_MIME: Record<string, AllowedMimeType> = {
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  pdf: 'application/pdf',
  mp4: 'video/mp4',
  webm: 'video/webm',
};

export function getMimeTypeFromFilename(filename: string): AllowedMimeType | null {
  if (!filename) return null;
  // Strip query string and fragment (handles S3 presigned URLs like file.jpg?X-Amz-Signature=...)
  const pathOnly = filename.split('?')[0].split('#')[0];
  const dotIndex = pathOnly.lastIndexOf('.');
  if (dotIndex === -1) return null;
  const extension = pathOnly.slice(dotIndex + 1).toLowerCase();
  return EXTENSION_TO_MIME[extension] ?? null;
}
